import React, { memo, useCallback } from 'react';

import {
    AppBar, Toolbar, List, ListItem, ListItemText, Divider,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import IconButton from '~/components/IconButton';
import Popover from '~/components/Popover';
import SubscriptionStatusTag from '~/components/SubscriptionStatusTag';
import UserAvatar from '~/components/UserAvatar';
import { connectScreenSize } from '~/helpers/screen-size-helper';
import useClassNames from '~/hooks/use-classnames';
import { actions } from '~/redux/ducks';
import thunks from '~/redux/thunks';
import colors from '~/values/colors';

import styles from './AppHeaderBar.module.scss';

const AppHeaderBar = memo(({
    isDesktop,
    toggleSidebar,
    sidebarCollapsed,
    removeAuthenticationData,
    history, user,
}) => {

    const { nome, email, foto: profilePicture } = user;

    const appBarClassName = useClassNames([
        styles.appBar, { [styles.appBarOpened]: isDesktop && !sidebarCollapsed },
    ]);

    const handleLogout = useCallback(() => {
        removeAuthenticationData();
        history.push('/login');
    }, [history, removeAuthenticationData]);

    const renderUserOptions = () => {
        return (
            <List component="nav" className={styles.userMenu}>
                <ListItem>
                    <ListItemText
                        primary={<b>{nome}</b>}
                        secondary={<b>{email}</b>}
                    />
                </ListItem>
                <Divider />
                <ListItem>
                    <Link className={styles.profileOption} to="/app/perfil">
                        Perfil
                    </Link>
                </ListItem>
                <Divider />
                <ListItem button>
                    <ListItemText
                        primary="Sair"
                        onClick={handleLogout}
                        className={styles.logoutOption}
                    />
                </ListItem>
            </List>
        );
    };

    return (
        <AppBar position="static" className={appBarClassName}>
            <Toolbar className={styles.header}>
                <div className={styles.menuButton}>
                    <IconButton
                        icon="menu"
                        onClick={toggleSidebar}
                        color={colors.textOnAccent}
                        title={sidebarCollapsed ? 'Abrir menu' : 'Fechar menu'}
                    >
                        <MenuIcon />
                    </IconButton>
                </div>
                <img
                    alt="DHO - Departamento Humano Organizacional"
                    src={require('~/assets/logo-dho-sispack-negativo.svg').default}
                    className={styles.logotipo}
                />
                <div className={styles.subscriptionAvatarContainer}>
                    <div>
                        <SubscriptionStatusTag />
                    </div>
                    <div className={styles.avatarContainer}>
                        <Popover
                            popoverId="user-popover"
                            popoverContent={renderUserOptions()}
                        >
                            <UserAvatar
                                name={nome}
                                email={email}
                                className={styles.avatar}
                                photo={profilePicture && profilePicture.caminho}
                                hidePopover
                            />
                        </Popover>
                    </div>
                </div>
            </Toolbar>
        </AppBar>

    );
});

AppHeaderBar.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    toggleSidebar: PropTypes.func.isRequired,
};

const mapStateToProps = ({ sidebarCollapsed, user }) => ({
    user,
    sidebarCollapsed,
});

const mapDispatchToProps = ({
    toggleSidebar: actions.sidebar.toggleSidebar,
    removeAuthenticationData: thunks.user.removeAuthenticationData,
});

export default connect(mapStateToProps, mapDispatchToProps)(connectScreenSize(withRouter(AppHeaderBar)));
